import {useEffect, useMemo} from 'react';
import {useParams, useRouteError} from 'react-router-dom';
import {useQueryClient} from '@tanstack/react-query';
import {AxiosError} from 'axios';

import {ROUTES} from '@/root/constants/routes';
import usePopup from '@/root/hooks/usePopup';
import {recommendKeys} from '@/root/queries/recommend';

import {DicaronCommonErrorCode} from '@/shared/constants/dicaronServerErrorCode';
import useAdvancedNavigate from '@/shared/hooks/useAdvancedNavigate';

const isCommonErrorCode = (code: string): code is DicaronCommonErrorCode =>
  Object.values(DicaronCommonErrorCode).includes(code as DicaronCommonErrorCode);

const RecommendedCardIntroError = () => {
  const error = useRouteError();
  const navigate = useAdvancedNavigate();
  const {recommendCode = ''} = useParams<{recommendCode: string}>();
  const {openPopup} = usePopup();
  const queryClient = useQueryClient();
  const errorCode = useMemo(() => {
    if (error instanceof AxiosError) {
      const responseErrorCode = error.response?.data.code;
      return isCommonErrorCode(responseErrorCode) ? responseErrorCode : null;
    }
    return null;
  }, []);

  useEffect(() => {
    // 실패시 api 재요청을 위해 캐시 제거
    queryClient.removeQueries({queryKey: recommendKeys.intro(recommendCode)});

    if (!errorCode) return;

    openPopup('SERVER_ERROR', {
      errorCode,
      onSubmit: () => {
        navigate(ROUTES.HOME, {keepSearchParams: true});
      }
    });
  }, []);

  if (!errorCode) {
    throw error;
  }

  return null;
};

export default RecommendedCardIntroError;
